import { Box, ListItemButton, Table, TableBody } from "@mui/material";
import { styled } from "@mui/material/styles";

type WhiteCardContainerProps = {
  disabled?: boolean;
  active?: boolean;
};

export const TableBodyStripedRows = styled(TableBody)(() => ({
  "& > *:nth-of-type(even)": {
    backgroundColor: "#FAFAFB",
  },
  "& > tr": {
    cursor: "pointer",
  },
}));

type StyledSalesPermissionStatusIndicatorProps = {
  larger?: boolean;
};

export const StyledSalesPermissionStatusIndicator = styled(Box, {
  shouldForwardProp: (prop) => prop !== "larger",
})<StyledSalesPermissionStatusIndicatorProps>(({ larger }) => ({
  width: larger ? "16px" : "8px",
  height: larger ? "16px" : "8px",
  borderRadius: "100%",
}));

export const TableStyled = styled(Table)(() => ({
  borderTopRightRadius: "8px",
  borderTopLeftRadius: "8px",
}));

export const WhiteCardContainer = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== "disabled" && prop !== "active",
})<WhiteCardContainerProps>(({ disabled, active }) => ({
  display: "flex",
  gap: "24px",
  padding: "1rem",
  boxShadow: "none",
  backgroundColor: active ? "#FFFFFF" : "#F3F3F7",
  color: disabled ? "#00000061" : "inherit",
  border: "solid 1px #000A441C",
  borderRadius: "8px",
  width: "600px",
  marginBottom: "16px",
  cursor: disabled ? "auto" : "pointer",
  "&:hover": {
    backgroundColor: disabled ? "#FFFFFF" : "rgba(0, 0, 0, 0.04)",
  },
}));

export const ActionButtonsContainer = styled(Box)(() => ({
  display: "flex",
  width: "100%",
  gap: "1rem",
  alignItems: "flex-end",
  flexDirection: "row-reverse",
  justifyContent: "space-between",
  marginTop: "8px",
  cursor: "grab",
}));

export const ModalContainer = styled(Box)(() => ({
  height: "inherit",
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));
